/*************************************************
 * Strip HTML tags from a string (server-safe)
 ************************************************/

export function stripHtml(html: string): string {

    // Remove HTML tags using regex
    let text = html.replace(/<[^>]*>/g, '');
    
    // Decode common HTML entities
    const entities: Record<string, string> = {
        '&nbsp;': ' ',
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&rsquo;': "'",
        '&lsquo;': "'",
        '&rdquo;': '"',
        '&ldquo;': '"',
        '&ndash;': '–',
        '&mdash;': '—',
        '&hellip;': '...',
    };
  
    // Replace HTML entities
    Object.entries(entities).forEach(([entity, char]) => {
        text = text.replace(new RegExp(entity, 'g'), char);
    });
    
    // Remove extra whitespace
    text = text.replace(/\s+/g, ' ').trim();
    
    return text;
}

/*****************************************
 * Truncate text to a maximum length
 *******************************************/
export function truncateText(text: string, maxLength: number = 200): string {

    if (text.length <= maxLength) return text;
    
    // Find the last space before maxLength to avoid cutting words
    const truncated = text.substring(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');
    
    if (lastSpace > 0) {
        return truncated.substring(0, lastSpace) + '...';
    }
    
    return truncated + '...';
}

/*****************************************
 * Truncate heading/title (optimized for headings)
 * Default 60 characters (ideal for blog card titles)
 *******************************************/
export function truncateHeading(heading: string, maxLength: number = 60): string {

    if (heading.length <= maxLength) return heading;
    
    // Find the last space before maxLength to avoid cutting words
    const truncated = heading.substring(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');
    
    if (lastSpace > 0) {
        return truncated.substring(0, lastSpace) + '...';
    }
    
    return truncated + '...';
}